import React, { useRef, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import IconButton from 'srcReact/components/common2/IconButton'
import { isEmail } from 'srcReact/helpers/validator'
import styles from './styles.module.scss'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function ByEmailChip({ workplaceId, isMobile, className, setEmails, setHasEmailErrors }) {
  const { t } = useTranslation()
  const emailChipsInputRef = useRef()

  const {
    invite: { success }
  } = useSelector((state) => state)
  const [emailValue, setEmailValue] = useState('')
  const [emailsChips, setEmailsChips] = useState([])
  const [countWrongEmails, setCountWrongEmails] = useState(0)
  const [hasError, setHasError] = useState(true)
  const [messageValue, setMessageValue] = useState('')

  useEffect(() => {
    if (success) {
      setEmailsChips([])
      setEmailValue('')
    }
  }, [success])

  useEffect(() => {
    isMailError()
    saveInStorage()
    setEmails(emailsChips)
    setHasEmailErrors(hasError)
  }, [emailsChips, emailValue, hasError])

  const handleFocus = () => {
    emailChipsInputRef.current.focus()
  }

  const handleChangeMailInput = (e) => {
    setEmailValue(e.target.value)
  }
  const isValid = (email) => {
    let emailObj = {}
    // create an object for the mail and assign error true or false
    const cleanEmail = email.replace(/(\r\n|\n|\r)/gm, '')
    !isEmail(cleanEmail)
      ? (emailObj = { email: cleanEmail, error: true })
      : (emailObj = { email: cleanEmail, error: false })
    return emailObj
  }

  const handleKeyDown = (e) => {
    // check if those keyboard keys have been touched
    if (
      (['Enter', 'Tab', ',', ' ', ';'].includes(e.key) || [13, 9, 188, 32, 186].includes(e.keyCode)) &&
      emailValue.trim() !== ''
    ) {
      e.preventDefault()
      const email = isValid(emailValue.trim())
      if (email) {
        setEmailsChips((prevEmailChips) => [...prevEmailChips, email])
        setEmailValue('')
      }
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()

    const paste = emailValue ? emailValue + e.clipboardData.getData('text') : e.clipboardData.getData('text')
    // split input value to get array, filter to remove empty value, map to create email object
    const toBeAdded = paste
      .split(/[\n;,\/ ]/)
      .filter((email) => email.trim() !== '')
      .map((email) => isValid(email))
    if (toBeAdded) {
      setEmailsChips((prevEmailChips) => [...prevEmailChips, ...toBeAdded])
      setEmailValue('')
    }
  }

  const handleBlur = () => {
    // check if those keyboard keys have been touched
    if (emailValue.trim() !== '') {
      if (isMobile) {
        // split input value to get array, filter to remove empty value, map to create email object
        const toBeAdded = emailValue
          .split(/[;,\/ -]/)
          .filter((email) => email.trim() !== '')
          .map((email) => isValid(email))
        if (toBeAdded) {
          setEmailsChips((prevEmailChips) => [...prevEmailChips, ...toBeAdded])
          setEmailValue('')
        }
      } else {
        const email = isValid(emailValue.trim())
        if (email) {
          setEmailsChips((prevEmailChips) => [...prevEmailChips, email])
          setEmailValue('')
        }
      }
    }
  }

  const removeAllWrongEmails = () => {
    setEmailsChips((prevEmailChips) => prevEmailChips.filter((email) => email.error === false))
    setHasError(false)
  }

  // save in storage mails and message
  const saveInStorage = () => {
    const data = { message: messageValue, emails: emailsChips.map((email) => email.email) }
    localStorage.setItem(`group_mixr_invite_${workplaceId}`, JSON.stringify(data))
  }

  const isMailError = () => {
    if (emailsChips?.length > 0) {
      const emailEmailsCount = emailsChips.filter((email) => email.error === true).length
      setCountWrongEmails(emailEmailsCount)
      setHasError(emailEmailsCount > 0)
    }
  }

  const handleDelete = (e, emailToRemove) => {
    e.stopPropagation()
    setEmailsChips((prevEmailChips) => prevEmailChips.filter((email) => email.email !== emailToRemove))
  }
  return (
    <div className={`${styles.inviteByEmail} ${className}`}>
      <h2 className={styles.title}>{t('formlabel.emails')}</h2>
      <h3 className={styles.subTitle}>{t('form.invite_form.label_emails')}</h3>
      <div onClick={handleFocus} className={styles.emailChipsContainer}>
        {emailsChips &&
          emailsChips.map((email, i) => (
            <div className={`${styles.item} ${email?.error && styles.error}`} key={i}>
              <span className={styles.email}>{email?.email}</span>
              <IconButton
                iconName='close24'
                iconSize='large'
                onClick={(e) => handleDelete(e, email?.email)}
                className={styles.delete}
                aria-label={'delete'}
              />
            </div>
          ))}
        <input
          ref={emailChipsInputRef}
          className={styles.input}
          placeholder={emailsChips?.length === 0 ? t('form.invite_form.placeholder_emails') : ''}
          value={emailValue}
          onChange={handleChangeMailInput}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          onBlur={handleBlur}
        />
      </div>
      {hasError && countWrongEmails > 0 && (
        <div className={styles.errorMessage}>
          <ErrorMessage text={`${countWrongEmails} ${countWrongEmails > 1 ? 'errors' : 'error'}.`} />
          <button className={styles.removeErrorChips} type='button' onClick={removeAllWrongEmails}>
            {t('invite_group_mixr.byEmail.removeErrorItems')}
          </button>
        </div>
      )}
    </div>
  )
}

export default ByEmailChip
